(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atmosa-article"]) return;
  try {
    
(function () {
  function fold() {
    if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) {
      document.querySelectorAll('.ma-a-toc details').forEach(function (d) { d.removeAttribute('open'); });
    }
  }
  if (document.readyState !== 'loading') fold(); else document.addEventListener('DOMContentLoaded', fold);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atmosa-brand-hero"]) return;
  try {
    
(function () {
  function init() {
    var els = document.querySelectorAll('.ma-b-reveal');
    var editor = window.Shopify && Shopify.designMode;
    if (editor || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function () { document.querySelectorAll('.ma-b-reveal').forEach(function (e) { e.classList.add('is-in'); }); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atmosa-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atmosa-home"] && !Shopify.designMode) return;
  try {
    

function initAtmosa(root){root.querySelectorAll('.atmosa-home').forEach(home=>{if(home.dataset.initialized)return;home.dataset.initialized='true';const form=home.querySelector('.ma-guide-form');form.addEventListener('submit',e=>{e.preventDefault();const data=new FormData(form),need=data.get('need'),surface=data.get('surface'),messages=home.querySelector('.ma-guide-messages').dataset,result=home.querySelector('.ma-guide-result'),large=surface==='xl'||(need==='fan'&&surface==='large');result.querySelector('[data-result-copy]').textContent=large?messages.large:messages[need];const a=result.querySelector('[data-result-link]');a.href=large?'/pages/contact':need==='fan'?'/collections/ventilateurs-de-plafond':'/collections/deshumidificateurs';result.hidden=false;result.focus({preventScroll:true});});const rows=home.querySelectorAll('[data-row]'),source=home.querySelector('.ma-compare-data');function compare(){home.querySelectorAll('.ma-compare-select').forEach(select=>{const slot=Number(select.dataset.slot),p=source.querySelector('[data-id="'+select.value+'"]').dataset;home.querySelector('[data-model-name="'+slot+'"]').textContent=p.name;rows.forEach(row=>row.querySelectorAll('td')[slot].textContent=p[row.dataset.row]||source.dataset.missing);});}home.querySelectorAll('.ma-compare-select').forEach(select=>select.addEventListener('change',compare));compare();});}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',()=>initAtmosa(document));}else{initAtmosa(document);}document.addEventListener('shopify:section:load',e=>initAtmosa(e.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atmosa-product-buybox"]) return;
  try {
    
(function () {
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (form.hasAttribute('data-ma-bundle')) {
      var v = new URLSearchParams(location.search).get('variant');
      var main = form.querySelector('[data-ma-main]');
      if (v && main) main.value = v;
      return;
    }
    if (form.__maBusy) return;
    var boxes = document.querySelectorAll('[data-ma-upsell]:checked');
    if (!boxes.length) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var items = [].map.call(boxes, function (b) { return { id: Number(b.value), quantity: 1 }; });
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .catch(function () {})
      .then(function () {
        form.__maBusy = true;
        if (form.requestSubmit) { form.requestSubmit(e.submitter || undefined); } else { form.submit(); }
        setTimeout(function () { form.__maBusy = false; }, 1500);
      });
  }, true);

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-ma-embed]');
    if (!a) return;
    e.preventDefault();
    var id = a.getAttribute('data-ma-id');
    var src = a.getAttribute('data-ma-embed') === 'vimeo'
      ? 'https://player.vimeo.com/video/' + id + '?autoplay=1&dnt=1'
      : 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
    var f = document.createElement('iframe');
    f.src = src;
    f.title = a.getAttribute('data-ma-title') || '';
    f.allow = 'autoplay; fullscreen; picture-in-picture';
    f.allowFullscreen = true;
    a.parentNode.replaceChild(f, a);
  });

  function initTabs(root) {
    (root || document).querySelectorAll('[data-ma-tabs]:not(.is-js)').forEach(function (box) {
      var tabs = box.querySelectorAll('[role="tab"]');
      var panels = box.querySelectorAll('[role="tabpanel"]');
      if (!tabs.length || tabs.length !== panels.length) return;
      box.classList.add('is-js');
      function show(i, focus) {
        tabs.forEach(function (t, k) {
          var on = k === i;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          panels[k].hidden = !on;
        });
        if (focus) tabs[i].focus();
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { show(i); });
        t.addEventListener('keydown', function (e) {
          var n = tabs.length;
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); show((i + (e.key === 'ArrowRight' ? 1 : n - 1)) % n, true); }
          else if (e.key === 'Home') { e.preventDefault(); show(0, true); }
          else if (e.key === 'End') { e.preventDefault(); show(n - 1, true); }
        });
      });
      show(0);
    });
  }
  if (document.readyState !== 'loading') initTabs(); else document.addEventListener('DOMContentLoaded', function () { initTabs(); });
  document.addEventListener('shopify:section:load', function (e) { initTabs(e.target); });

  function money(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(cents / 100);
    } catch (err) { return ''; }
  }
  function updateBundles() {
    var current = new URLSearchParams(location.search).get('variant');
    document.querySelectorAll('form[data-ma-bundle]').forEach(function (form) {
      var prices; try { prices = JSON.parse(form.getAttribute('data-prices')); } catch (err) { return; }
      var id = current || form.getAttribute('data-default');
      var mainPrice = prices[id];
      if (mainPrice === undefined) return;
      var total = mainPrice + Number(form.getAttribute('data-acc-price'));
      var out = form.querySelector('[data-ma-total]');
      if (out) out.textContent = money(total);
    });
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, updateBundles);
  } else {
    document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('variant-selects, secondary-variant-select, secondary-variant-select-separate')) updateBundles(); });
  }
  if (document.readyState !== 'loading') updateBundles(); else document.addEventListener('DOMContentLoaded', updateBundles);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atmosa-product-polish"]) return;
  try {
    
(function () {
  var COLORS = { noir: '#1d1d1b', blanc: '#f4f2ec', bois: '#b98a5e', 'chêne': '#c8a06a', argent: '#c4c7c9', sombre: '#3a3a3a' };
  function dotFor(text) {
    var parts = text.toLowerCase().split('/').map(function (s) { return s.trim(); });
    var cs = parts.map(function (w) { return COLORS[w]; }).filter(Boolean);
    if (!cs.length || cs.length !== parts.length) return null;
    return cs.length === 1 ? cs[0] : 'linear-gradient(90deg,' + cs[0] + ' 50%,' + cs[1] + ' 50%)';
  }
  function enhance(root) {
    (root || document).querySelectorAll('variant-selects .product-form__input--pill').forEach(function (box) {
      var lab = box.querySelector('.form__label');
      var isColor = lab && /couleur|coloris/i.test(lab.textContent);
      box.querySelectorAll('label[for]').forEach(function (l) {
        if (l.getAttribute('data-ma-done') || l.classList.contains('form__label')) return;
        var node = [].find.call(l.childNodes, function (n) { return n.nodeType === 3 && n.textContent.trim(); });
        if (!node) return;
        var txt = node.textContent.trim();
        l.setAttribute('data-ma-done', '1');
        var m = txt.match(/^(.+?)\s*\((.+)\)$/);
        if (m) {
          var main = document.createElement('span'); main.className = 'ma-pill-main'; main.textContent = m[1];
          var hint = document.createElement('span'); hint.className = 'ma-pill-hint'; hint.textContent = m[2];
          l.insertBefore(main, node); l.insertBefore(hint, node); node.parentNode.removeChild(node);
          l.classList.add('ma-pill--two');
        } else if (isColor) {
          var c = dotFor(txt);
          if (c) {
            var d = document.createElement('span'); d.className = 'ma-pill-dot'; d.style.background = c; d.setAttribute('aria-hidden', 'true');
            l.insertBefore(d, node); l.classList.add('ma-pill--color');
          }
        }
      });
    });
  }
  function start() {
    enhance();
    var info = document.querySelector('product-info');
    if (info && 'MutationObserver' in window) {
      new MutationObserver(function () { enhance(); }).observe(info, { childList: true, subtree: true });
    }
  }
  if (document.readyState !== 'loading') start(); else document.addEventListener('DOMContentLoaded', start);
  document.addEventListener('shopify:section:load', function () { enhance(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atmosa-sticky-atc"] && !Shopify.designMode) return;
  try {
    
    if (!customElements.get('sticky-atc')) {
      customElements.define('sticky-atc', class StickyAtc extends HTMLElement {
        connectedCallback() {
          this.price = this.querySelector('[data-sticky-price]');
          this.select = this.querySelector('[data-sticky-select]');
          this.btn = this.querySelector('[data-sticky-add]');
          this.img = this.querySelector('[data-sticky-img]');
          try { this.variants = JSON.parse(this.querySelector('[data-sticky-variants]').textContent); } catch (e) { this.variants = []; }
          this.fmt = new Intl.NumberFormat(this.dataset.locale || 'fr', { style: 'currency', currency: this.dataset.currency || 'EUR' });

          this.main = document.querySelector('product-info product-form form[data-type="add-to-cart-form"]');
          this.mainBtn = this.main ? this.main.querySelector('button[name="add"]') : null;
          if (!this.main || !this.mainBtn) return;

          this.onVariant = this.onVariant.bind(this);
          this.unsubscribe = (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) ? subscribe(PUB_SUB_EVENTS.variantChange, this.onVariant) : null;

          this.btn.addEventListener('click', () => {
            if (this.mainBtn.disabled) return;
            this.mainBtn.click();
          });

          if (this.select) {
            this.select.addEventListener('change', () => this.selectVariant(this.select.value));
          }

          this.observer = new IntersectionObserver((entries) => {
            const e = entries[0];
            const passed = !e.isIntersecting && e.boundingClientRect.top < 0;
            this.toggle(passed);
          }, { threshold: 0 });
          this.observer.observe(this.mainBtn);
          this.bodyObserver = new MutationObserver(() => this.toggle(this.wanted));
          this.bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
          this.decorateMainButton(this.currentVariant());
        }

        disconnectedCallback() {
          if (this.unsubscribe) this.unsubscribe();
          if (this.observer) this.observer.disconnect();
          if (this.bodyObserver) this.bodyObserver.disconnect();
          document.body.classList.remove('ma-has-sticky');
        }

        currentVariant() {
          const id = this.main.querySelector('input[name="id"]')?.value;
          return this.variants.find((v) => String(v.id) === String(id)) || null;
        }

        toggle(wanted) {
          this.wanted = wanted;
          const blocked = /(^|\s)overflow-hidden/.test(document.body.className);
          const show = !!wanted && !blocked;
          if (show) this.hidden = false;
          this.classList.toggle('is-visible', show);
          this.setAttribute('aria-hidden', show ? 'false' : 'true');
          this.querySelectorAll('button, select').forEach((el) => { el.tabIndex = show ? 0 : -1; });
          document.body.classList.toggle('ma-has-sticky', show);
          if (!show) setTimeout(() => { if (!this.classList.contains('is-visible')) this.hidden = true; }, 260);
        }

        money(cents) {
          return this.fmt.format(cents / 100);
        }

        onVariant(event) {
          const variant = event && event.data ? event.data.variant : null;
          if (!variant) {
            this.btn.disabled = true;
            this.btn.textContent = window.variantStrings ? window.variantStrings.unavailable : this.dataset.soldoutLabel;
            return;
          }
          this.price.textContent = this.money(variant.price);
          if (this.select && String(this.select.value) !== String(variant.id)) this.select.value = String(variant.id);
          if (this.img && variant.featured_image && variant.featured_image.src) {
            this.img.src = variant.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2');
          }
          this.btn.disabled = !variant.available;
          this.btn.textContent = variant.available ? this.dataset.buttonLabel : this.dataset.soldoutLabel;
          this.decorateMainButton(variant);
        }

        decorateMainButton(variant) {
          /* Le bouton principal affiche « Ajouter au panier • prix » ; Dawn remet le libellé seul à chaque changement. */
          if (!variant || !variant.available) return;
          const span = this.mainBtn.querySelector('span');
          if (!span || span.querySelector('.ma-atc-price')) {
            const p = span && span.querySelector('.ma-atc-price');
            if (p) p.textContent = this.money(variant.price);
            return;
          }
          span.textContent = this.dataset.addLabel;
          const sep = document.createElement('span'); sep.className = 'ma-atc-sep'; sep.setAttribute('aria-hidden', 'true'); sep.textContent = ' • ';
          const price = document.createElement('span'); price.className = 'ma-atc-price'; price.textContent = this.money(variant.price);
          span.appendChild(sep); span.appendChild(price);
        }

        selectVariant(id) {
          const variant = this.variants.find((v) => String(v.id) === String(id));
          const vs = document.querySelector('product-info variant-selects');
          if (!variant || !vs) return;
          const fieldsets = vs.querySelectorAll('fieldset');
          const selects = vs.querySelectorAll('select');
          let last = null;
          variant.options.forEach((value, i) => {
            if (fieldsets[i]) {
              const input = Array.from(fieldsets[i].querySelectorAll('input')).find((inp) => inp.value === value);
              if (input && !input.checked) { input.checked = true; last = input; }
            } else if (selects[i] && selects[i].value !== value) {
              selects[i].value = value; last = selects[i];
            }
          });
          if (last) last.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
